/**
 * Translations for LearnPage (v0.14.0 PR-7).
 * LearnPage bundles the standalone /quiz + /imagine routes under one
 * bottom-dock entry.
 */
const learn = {
  zh: {
    'learn.title': '学习',
    'learn.tab.quiz': '📝 智慧森林',
    'learn.tab.imagine': '💭 无限遐想',
  },
  en: {
    'learn.title': 'Learn',
    'learn.tab.quiz': '📝 Wisdom Forest',
    'learn.tab.imagine': '💭 Imagine',
  },
};

export default learn;
